import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/metric-hub/dashboard/DashboardPage';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function DashboardRoute() {
  useTrackSkillOnDwell('view_dashboard');
  return <DashboardPage />;
}

export const Route = createFileRoute('/_authed/metric-hub/dashboard')({
  component: DashboardRoute,
});
